import React, { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const years = Array.from({ length: 50 }, (_, i) => new Date().getFullYear() - i);

export function ModifyCertificate({ expertID, selectedCertification, getExpertCertifications, onCancel }) {
  const { API_URL } = useContext(UrlContext);
  const [certificationName, setCertificationName] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  useEffect(() => {
    if (selectedCertification) {
      setCertificationName(selectedCertification.certificationName || "");
      if (selectedCertification.certificationDate) {
        const dateParts = selectedCertification.certificationDate.replace("Issued ", "").split(" ");
        setMonth(dateParts[0]);
        setYear(dateParts[1]);
      }
    }
  }, [selectedCertification]);

  const modifyExpertCertifications = async (expertCertification) => {
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    const requestBody = {
      expertID: expertID,
      certificationID: selectedCertification.certificationID,
      certification: expertCertification,
    };
    
    try {
      let modifiedUrl = "modify-eph-certification-data";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
    
      const responseData = await response.json();
      if (responseData.status === "success") {
        getExpertCertifications();
        Swal.fire({title: "Success!", text: responseData.text, icon: "success", showConfirmButton: false, timer: 1500});
      } else if (responseData.status === "error") {
        Swal.fire({ title: "Error!", text: responseData.text, icon: "error", confirmButtonColor: "#365565"});
      } else {
        Swal.fire({ title: "Error!", text: "Failed to modify certificate!", icon: "error", confirmButtonColor: "#365565"});
      }
    } catch (error) {
      Swal.fire({title: "Error!", text: error,  icon: "error", confirmButtonColor: "#365565"});
    }
  };

  const deleteExpertCertifications = async () => {
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    const requestBody = {
      certificationID: selectedCertification.certificationID,
    };
    
    try {
      let modifiedUrl = "delete-eph-certification-data";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
    
      const responseData = await response.json();
      if (responseData.status === "success") {
        getExpertCertifications();
        Swal.fire({title: "Success!", text: responseData.text, icon: "success", showConfirmButton: false, timer: 1500});
      } else if (responseData.status === "error") {
        Swal.fire({ title: "Error!", text: responseData.text, icon: "error", confirmButtonColor: "#365565"});
      } else {
        Swal.fire({ title: "Error!", text: "Failed to delete certificate!", icon: "error", confirmButtonColor: "#365565"});
      }
    } catch (error) {
      Swal.fire({title: "Error!", text: error,  icon: "error", confirmButtonColor: "#365565"});
    }
  };

  const handleSave = async () => {
    if (!certificationName || !month || !year) {
      alert("Please fill all fields.");
      return;
    }

    const updated = {
      certificationName,
      certificationDate: `Issued ${month} ${year}`
    };

    // setCertificationData(prev =>
    //   prev.map(cert =>
    //     cert === selectedCertification ? updated : cert
    //   )
    // );

    await modifyExpertCertifications(updated);
    onCancel();
  };

  const handleDelete = async () => {
    // const updated = certificationData.filter(cert => cert !== selectedCertification);
    // setCertificationData(updated);
    await deleteExpertCertifications();
    onCancel();
  };

  return (
    <div className="flex flex-col gap-2">
      <input
        className="w-full border-b border-gray-300 hover:border-[#365561] focus:border-[#365561] focus:outline-none text-sm pb-0.1"
        placeholder="Certification Name"
        value={certificationName}
        onChange={(e) => setCertificationName(e.target.value)}
      />
      <div className="flex gap-2">
        <select
          className="border-b border-gray-300 hover:border-[#365561] focus:border-[#365561] focus:outline-none text-sm pb-0.1 bg-transparent"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
        >
          <option value="">Month</option>
          {months.map(m => <option key={m} value={m}>{m}</option>)}
        </select>
        <select
          className="border-b border-gray-300 hover:border-[#365561] focus:border-[#365561] focus:outline-none text-sm pb-0.1 bg-transparent"
          value={year}
          onChange={(e) => setYear(e.target.value)}
        >
          <option value="">Year</option>
          {years.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>

      <div className="flex justify-end gap-4 mt-6">
        <button
          onClick={handleDelete}
          className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700"
        >
          Delete
        </button>
        <button
          onClick={handleSave}
          className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700"
        >
          Save
        </button>
      </div>
    </div>
  );
}